module.exports = "/_next/static/images/harajuku_hideout-1175f0854c0d5269876fe28b07abcba3.jpg";